module.exports = __webpack_public_path__ + "img/filter.2a44ab5e.svg";